import React from 'react';
import { Column } from 'react-table';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { FeedbackReport } from 'http/Api/Feedback/types';
import { getDateTimeFromFormat } from 'helpers/datetime';

import { withArrow } from 'components/Table/helpers';

import style from './FeedbackReportTab.module.scss';
import { getFeedbackWordStatus } from './utils';
import { getFeedbackRatingColor } from 'helpers/feedback';

const config = (): Column[] => [
  {
    Header: withArrow('title.date'),
    accessor: 'date',
    resizable: false,
    width: 120,
    sortMethod: (a: string, b: string) =>
      getDateTimeFromFormat(a).toMillis() - getDateTimeFromFormat(b).toMillis(),
  },
  {
    Header: withArrow('title.report.feedback.rating'),
    accessor: 'rating',
    resizable: true,
    className: style.td__rating,
    width: 170,
    Cell: cell => {
      const rating = cell.value as FeedbackReport['rating'];

      return (
        <div
          className={style.cell__rating}
          style={{ color: getFeedbackRatingColor(rating) }}
        >
          {rating}
        </div>
      );
    },
  },
  {
    Header: withArrow('title.report.feedback.words'),
    accessor: 'words',
    resizable: true,
    sortable: false,
    width: 220,
    className: style.td__list,
    Cell: cell => {
      const words = cell.value as FeedbackReport['words'];

      return (
        <>
          {words.map(word => (
            <div
              key={word}
              className={classNames(
                style.cell__word,
                style[getFeedbackWordStatus(word)],
              )}
            >
              <FormattedMessage
                id={`title.report.feedback.words.${word}`}
                defaultMessage={word}
              />
            </div>
          ))}
        </>
      );
    },
  },
  {
    Header: withArrow('title.report.feedback.items'),
    accessor: 'itemFeedbacks',
    resizable: false,
    sortable: false,
    className: style.td__list,
    Cell: cell => {
      const items = cell.value as FeedbackReport['itemFeedbacks'];

      return (
        <>
          {items.map(item => (
            <div key={item.menuItemId} className={style.cell__menuItem}>
              <div className={style.cell__menuItem_title}>{item.title}</div>
              <div className={style.cell__menuItem_rating}>
                <span className={style.cell__menuItem_ratingTitle}>
                  <FormattedMessage id="title.report.feedback.items.rating" />:
                </span>
                <span style={{ color: getFeedbackRatingColor(item.rating) }}>
                  {item.rating}
                </span>
              </div>
              {!!item.text && (
                <div className={style.cell__menuItem_text} title={item.text}>
                  <span className={style.cell__menuItem_textTitle}>
                    <FormattedMessage id="title.report.feedback.items.text" />:
                  </span>
                  {item.text}
                </div>
              )}
            </div>
          ))}
        </>
      );
    },
  },
];

export default config;
